import React from 'react'
import AddAgencyOfficialsBreadCrumb from './AddAgencyOfficialsBreadCrumb';
import AddNewAgencyOfficials from './AddNewAgencyOfficials';

function AddNewAgencyOfficialsPage() {
    return ( 
        <div className= "container-fluid">
            <AddAgencyOfficialsBreadCrumb />
            <AddNewAgencyOfficials />
        </div>
     );
}

export default AddNewAgencyOfficialsPage;